// @flow
import styled from 'styled-components';
import { albasterGrey, blackGrey, cleanWhite, jetBlack } from '../../../colors';
import CheckBoxIcon from '../../../icons/checkbox';
/*::
import type { Node } from 'react';

export type ItemThemeType = {|
  Main: * => Node,
  Label: * => Node,
  Highlight: * => Node,
  CheckBox: * => Node,
|};
*/

var DefaultTheme
/*: ItemThemeType */
= {
  Main: styled.div.withConfig({
    displayName: "theme__Main",
    componentId: "sc-1ow847x-0"
  })(["padding:0 1rem;height:4.3rem;line-height:4.3rem;color:", ";background:", ";cursor:pointer;user-select:none;display:flex;align-items:center;"], blackGrey(), function (pr) {
    return pr.highlight ? albasterGrey() : cleanWhite();
  }),
  Label: styled.div.withConfig({
    displayName: "theme__Label",
    componentId: "sc-1ow847x-1"
  })(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]),
  Highlight: styled.span.withConfig({
    displayName: "theme__Highlight",
    componentId: "sc-1ow847x-2"
  })(["color:", ";font-weight:300;"], jetBlack()),
  CheckBox: styled(CheckBoxIcon).withConfig({
    displayName: "theme__CheckBox",
    componentId: "sc-1ow847x-3"
  })(["flex-shrink:0;margin-right:1rem;"])
};
export default DefaultTheme;